<template>
  <span
    :style="bgStyle"
    tabindex="0"
    @click="$emit('click', value)"
  >
    <span class="dot">
      <span v-if="checkedText && value" class="text">
        {{ checkedText }}
      </span>

      <span v-if="uncheckedText && !value" class="text">
        {{ uncheckedText }}
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'HeaderToggleRouteSwitch',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    checkedText: {
      type: String,
      default: null
    },
    uncheckedText: {
      type: String,
      default: null
    },
    width: {
      type: [Number, String],
      default: 75
    },
    height: {
      type: [Number, String],
      default: 25
    }
  },
  computed: {
    bgStyle () {
      const styles = {
        width: this.width + 'px',
        height: this.height + 'px'
      };
      return styles;
    }
  }
};
</script>

<style lang="scss">
  .switch {
    outline: none;
    margin-bottom: 5px;
    transform: skewX(-15deg);
    cursor: pointer;
    display: flex;
    align-items: center;
    border-radius: 0px;
    overflow: hidden;
    transition: background-color ease 0.2s, width ease 0.2s, height ease 0.2s;

    .dot {
      position: relative;
      display: flex;
      align-items: center;
      border-radius: 0;
      background: $color-primary-trophy;
      transition: margin ease 0.2s;
      width: 18px;
      height: 18px;
    }

    .text {
      position: absolute;
      user-select: none;
      transform: skewX(15deg);
      text-align: center;
    }

    &.dtm {
      border: $color-primary-trophy 2px solid;

      .dot {
        background: $color-primary-trophy;
        margin-left: 79px;
      }

      .text {
        color: $color-primary-trophy;
        line-height: 1;
        font-size: 11px;
        font-weight: bolder;
        right: 33px;
      }
    }

    &.dtm-trophy {
      border: $color-bg-trophy 2px solid;

      .dot {
        background: $color-bg-trophy;
        margin-left: 3px;
      }

      .text {
        color: $color-bg-trophy;
        font-size: larger;
        font-weight: bolder;
        left: 33px;
      }
    }
  }

 @media (max-width: map_get($grid-breakpoints, 'lg')) {
   .switch {
     &.dtm {
       .dot {
         width: 15px;
         height: 15px;
         margin-top: 3px;
       }
     }
     &.dtm-trophy {
       border: $color-primary-trophy 2px solid;

       .dot {
         background: $color-primary-trophy;
         width: 15px;
         height: 15px;
         margin-top: 3px;
       }
       .text {
         color: $color-primary-trophy;
       }
     }
   }
 }

  @media all and (-ms-high-contrast: none) {
    .vue-toggles .text {
      top: 50%;
      transform: translateY(-50%);
    }
  }
  @media (prefers-reduced-motion) {
    .vue-toggles,
    .vue-toggles *,
    .vue-toggles *::before,
    .vue-toggles *::after {
      animation: none !important;
      transition: none !important;
      transition-duration: none !important;
    }
  }
</style>
